import React, { useContext, useEffect } from "react";
import { Alert as MuiAlert } from "@mui/material";
import { Context } from "../Context/ErrorContext";

const Alert = () => {
  const { setError, error } = useContext(Context);

  useEffect(() => {
    if (error) {
      setTimeout(() => setError(""), 3000);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return error ? (
    <MuiAlert
      variant="filled"
      severity="error"
      className={"absolute bottom-2 left-2 z-[5000]"}
      onClose={() => setError("")}
    >
      {error}
    </MuiAlert>
  ) : null;
};

export default Alert;
